define(['handlebars', 'i18next'], function(handlebars, i18next) {

	return function(key, options) {

		var result = i18next.t(key, options.hash);
		return new handlebars.SafeString(result);
	}

});
